import { Link } from 'react-router-dom';
import Container from '@/components/base/Container';
import Eyebrow from '@/components/base/Eyebrow';
import TitleReveal from '@/components/base/TitleReveal';
import FaqList from '@/components/feature/FaqList';

export default function Faq() {
  return (
    <section className="bg-background-50 py-20 md:py-32">
      <Container>
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-16">
          <div>
            <Eyebrow label="FAQ" />
            <TitleReveal className="mt-6 text-[34px] md:text-[48px] lg:text-[54px] font-medium leading-[1.05] tracking-[-0.025em] text-foreground-950">
              Questions, Answered Plainly.
            </TitleReveal>
            <Link to="/pricing" className="mt-8 inline-flex items-center gap-2 whitespace-nowrap text-sm text-foreground-950 mw-link">
              How Our Pricing Works <span className="mw-arrow">&rarr;</span>
            </Link>
          </div>
          <FaqList />
        </div>
      </Container>
    </section>
  );
}